import React from 'react';
import DictItems from "@pages/dictionary/DictItems";
import {EXTRACT_CONTENT_DICTS} from "@app/constants/Dicts";

const DictContentList = () => {
    return (
        <div className="container-fluid">
            <div className="card card-primary">
                <div className="card-header">
                    <h3 className="card-title">Từ điển nội dung bóc tách</h3>
                </div>
                <div className="card-body">
                    <div className="row">
                        {EXTRACT_CONTENT_DICTS.map(item => (
                            <div className="col-sm-4">
                                <DictItems dictType={item.type} title={item.title}/>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DictContentList;
